export const headApi = `https://api.bangles.org.in/api/rest`;